
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650505633363",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3967",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M849.1 634.7c-136.6-87.1-176.9-113.3-236.7-121.3 4 15.8 6.3 32.8 6.3 50.5 0 67.1-31.6 124-75.2 143.3v-89.3h-57.8v92.3c-47.6-15.7-82.9-75.3-82.9-146.3 0-17.2 2.1-33.7 5.9-49.1-56.5 9.7-103.8 38.6-244.1 124.8-46.8 31.1-74.2 184.5-74.2 225.1 0 106.5 188.2 77.1 420.3 77.1S931 971.2 931 864.7c0.1-42.8-30.4-198-81.9-230z",
        "p-id": "3968",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512.7 604.4l32.7-59.7-32.7-32.8-32.8 32.8z",
        "p-id": "3969",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M510.7 269.5m-200.2 0a200.2 200.2 0 1 0 400.4 0 200.2 200.2 0 1 0-400.4 0Z",
        "p-id": "3970",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  